<template>
  <div>
    <Layout>
      <div class="bg-white border">
        <div class="border-b px-10 py-5">
          <h1 class="font-medium text-gray-700 text-lg">STG Email</h1>
          <p class="text-sm text-gray-500">Staging Email as Primary Key - Cordial account 99104</p>
        </div>
        <div class="px-10 py-5">
          <SegmentTester />
        </div>
      </div>
    </Layout>
  </div>
</template>

<script>
import Layout from '../components/Layout'
import SegmentTester from '../components/SegmentTester.vue'

export default {
  components: {
    SegmentTester,
    Layout,
  }
}
</script>